import React from "react";
import { Chrono } from "react-chrono";
import { useTranslation } from "react-i18next";

const Timeline = () => {
  const { t } = useTranslation();

  const items = [
    {
      title: "29 Aug",
      url: "#",
      cardDetailedText: (
        <>
          <strong> {t('timeline_heading1')}:</strong> <br></br> {t('timeline_description1')}
        </>
      ),
    },
    {
      title: "29 Aug - 20 Sep ",
      url: "#",
      cardDetailedText: (
        <>
          <strong>{t('timeline_heading2')}:</strong> <br></br> {t('timeline_description2')}
        </>
      ),
    },
    {
      title: "21 Sep - 25 Dec ",
      url: "#",
      cardDetailedText: (
        <>
          <strong>{t('timeline_heading3')}:</strong> <br></br>{t('timeline_description3')}
        </>
      ),
    },
    {
      title: "25 Dec ",
      url: "#",
      // cardDetailedText: 'Ceremonies held across all participants constituencies',
      cardDetailedText: (
        <>
          <strong>{t('timeline_heading4')}:</strong><br></br> {t('timeline_description4')}
        </>
      ),
    },
  ];

  return (
    <>
      <div className="chrono-wrapper ">
        {/* Show timeline bar only — no cards */}
        <Chrono
          items={items}
          mode="HORIZONTAL"
          cardWidth={160}
          cardHeight={0} // disables internal card rendering
          allowDynamicUpdate={false}
          slideShow={false}
          disableClickOnCircle={true} // this disables circle clicks
          theme={{
            primary: "red",
            titleColor: "#000",
            cardBgColor: "transparent",
          }}
        />

        <div className="custom-card-container ">
          {items.map((item, index) => (
            <div className="custom-card-slot" key={index}>
              <div className="custom-card">
                <p>{item.cardDetailedText}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Timeline;
